/* eslint-disable */
import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { useNavigate, useParams } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Container, Stack, TextField, Chip, Avatar, Tabs, Tab, IconButton, Tooltip, Grid } from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';
import Divider from '@material-ui/core/Divider';
import Page from '../../../Page';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Button from '@material-ui/core/Button';
import { ToastContainer, toast } from 'react-toastify';
import MenuItem from '@material-ui/core/MenuItem';
import Card from '@material-ui/core/Card';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import { makeStyles } from '@material-ui/styles';
import AddBoxIcon from '@material-ui/icons/AddBox';
import DeleteIcon from '@material-ui/icons/Delete';
import Paper from '@material-ui/core/Paper';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import EditIcon from '@material-ui/icons/Edit';
import Delete from '@material-ui/icons/Delete';
import Collapse from '@material-ui/core/Collapse';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import services from '../Service';
import TokenDecoder from 'src/helpers/TokenDecoder';
import permissionAuth from 'src/utils/permissionAuth';
import { func } from 'prop-types';
import moment from 'moment';
import { Autocomplete } from '@mui/material';
import { AlertDialog } from './../../Common/AlertDialog';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import _ from 'lodash';
import SearchNotFound from '../../../SearchNotFound';
import { CustomPickingTableTable } from '../Pages/PickingTable';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';

var screenCode = "FARMERPRODUCTPLOTS"

export default function FarmerProductPlotsView(props) {
  const navigate = useNavigate();
  const { productID } = useParams();
  const [pageProps, setPageProps] = useState({
    editingID: 0,
    isEdit: true,
    submitButtonName: 'Update',
    pageheadername: 'Farmer Product Plots'
  });
  const [isManualPickings, setIsManualPickings] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [openPlot, setOpenPlot] = React.useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [isHidden, setIsHidden] = useState(false);
  const [pikingsDetails, setPikingsDetails] = useState([]);




  const handleClickOpen = (data) => {
    setPlotData({
      ...plotData,
      plotTypeID: data.plotTypeID,
    })
    setCropDetails(data);
    setIsUpdate(false);
    setOpen(true);
    cropFieldsClear();
  };
  const handleClose = () => {
    cropFieldsClear();
    setOpen(false);
    setIsManualPickings(false);
  };

  const handleClickPlotOpen = () => {
    const highestPlotNo = plotDetails.reduce((max, plot) => Math.max(max, plot.plotNo), 0);
    const nextPlotNo = highestPlotNo + 1;
    plotFieldsClear();
    setOpenPlot(true);
    setIsUpdate(false);
    setPlotData({
      ...plotData,
      plotNo: nextPlotNo.toString(),
    })
  };
  const handlePlotClose = () => {
    plotFieldsClear();
    setOpenPlot(false);
  };

  const [date, setDate] = React.useState(new Date());
  const [isTable, setIsTable] = useState(false);
  const [groupList, setGroupList] = useState([]);
  const [operationEntityList, setOperationEntityList] = useState([]);
  const [route, setRoute] = useState([]);
  const [farmer, setFarmer] = useState([]);
  const [plotDetails, setPlotDetails] = useState([]);
  const [cropDetails, setCropDetails] = useState([]);
  const [unitDetails, setUnitDetails] = useState([]);
  const [details, setDetails] = useState([]);
  const [farmerCollectionCenterDetails, setFarmerCollectionCenterDetails] = useState([]);
  const [productcatogery, setProductcatogery] = useState([]);
  const [productList, setProductList] = useState([]);
  const [productVarietyList, setProductVarietyList] = useState([]);
  const [pickingTableError, setPickingTableError] = useState(false);
  const [isAddButtonEnable, setIsAddButtonEnable] = useState(false);

  const [message, setMessage] = useState("Plot Remove Confirmation");
  const [message2, setMessage2] = useState("Crop Remove Confirmation");
  const [EnableConfirmMessage, setEnableConfirmMessage] = useState(false);
  const [EnableConfirmMessage2, setEnableConfirmMessage2] = useState(false);
  const [plotPopUpDetails, setPlotPopUpDetails] = useState();
  const [PlotCropPopUpDetails, setPlotCropPopUpDetails] = useState();
  const [IsFarmerClear, setIsFarmerClear] = useState(false);
  const [approveOpen, setApproveOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFarmer, setSelectedFarmer] = useState([]);
  const [requestData, setRequestData] = useState({
    farmerID: '',
    requestReason: '',
    statusID: 0,
    farmerPlotCropMappingID: '',
    farmerPlotMappingID: ''
  })



  const [formData, setFormData] = useState({
    groupID: '0',
    operationEntityID: '0',
    collectionCenterID: '0',
    farmerID: '0',
    farmerName: ''
  });

  const [plotData, setPlotData] = useState({
    plotNo: '0',
    plotName: '',
    plotMethodID: '0',
    plotCategoryID: '0',
    collectionCenterID: '0',
    plotTypeID: '1',
    unitID: '3',
    perches: '0',
    acres: ''
  });

  const [cropData, setCropData] = useState({
    productCategoryID: '0',
    cropID: '0',
    productVarietyID: '0',
    cultivationPercentage: 0,
    date: '',
    startDate: '',
    endDate: '',
    yield: '',
    noOfPikings: ''
  });

  const PopUpStyle = makeStyles((theme) => ({
    root: {
      '& > *': {
        width: '25ch'
      }
    }
  }));

  const useStyles = makeStyles({
    root: {
      width: '100%',
      overflowX: 'auto'
    },
  });

  const useRowStyles = makeStyles({
    root: {
      '& > *': {
        borderBottom: 'unset',
      },
    },
  });

  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });
  const [value, setValue] = useState(0);
  const handleChange2 = (event, newValue) => {
    setValue(newValue);
  };

  const popUpClass = PopUpStyle();
  const classes = useStyles();

  const onKeyDown = (e) => {
    e.preventDefault();
  };

  function Row(props) {
    const { row } = props;
    const [open, setOpen] = React.useState(true);
    const classes = useRowStyles();
    return (
      <React.Fragment>
        <TableRow className={classes.root}>
          <TableCell>
            <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          <TableCell component="th" scope="row">
            {row.plotNo}
          </TableCell>
          <TableCell align="left">{row.plotName}</TableCell>
          <TableCell align="right">{row.acres}</TableCell>
          <TableCell align="left">{row.plotMethodID == 0 ? '-' : row.plotMethodID == 1 ? 'Bee Safe' : row.plotMethodID == 2 ? 'Gap' : 'Normal'}</TableCell>
          <TableCell align="left">{row.plotCategoryID == 0 ? '-' : row.plotCategoryID == 1 ? 'Modernize' : 'Non Modernize'}</TableCell>
          <TableCell align="left">{row.plotTypeID == 0 ? '-' : row.plotTypeID == 1 ? 'Tunnel' : 'Plot'}</TableCell>
          <TableCell align="right">{parseInt(row.totalCultivatedPrecentage) + ' %'}</TableCell>

          {row.location == null ?
            <TableCell align="center">
              <Tooltip title="Cannot Perform Any Actions">
                <Chip label="Do not have a Geo-location" variant="outlined" color='error' />
              </Tooltip>
            </TableCell>

            :

            <TableCell align="center">
              {value == 0 ?
                <Tooltip title="Add Non Seasonal Crop">
                  <IconButton onClick={() => handleClickOpen(row)}>
                    <AddBoxIcon />
                  </IconButton>
                </Tooltip> : null}
              {value == 1 ?
                <Tooltip title="Add Seasonal Crop">
                  <IconButton onClick={() => handleClickOpen(row)}>
                    <AddBoxIcon />
                  </IconButton>
                </Tooltip> : null}
              {!row.farmerPlotCropCount != 0 ?
                <Tooltip title="Delete Plot">
                  <IconButton aria-label="delete" onClick={() => plotRemovePopUp(row)}>
                    <Delete />
                  </IconButton>
                </Tooltip> : null}
              {!row.farmerPlotCropCount != 0 ?
                <Tooltip title="Edit Plot">
                  <IconButton aria-label="delete" onClick={() => setupdatePlot(row)}>
                    <EditIcon />
                  </IconButton>
                </Tooltip> : null}
            </TableCell>
          }
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={10}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              {row.cropDetails.length != 0 ?
                <Box margin={1}/*  marginLeft={2} */>
                  <Typography variant="h6" gutterBottom component="div">
                    Crop Details
                  </Typography>
                  <Table size="small" aria-label="purchases">
                    <TableHead>
                      <TableRow>
                        <TableCell style={{ fontWeight: 'bold' }}>Crop</TableCell>
                        <TableCell style={{ fontWeight: 'bold' }}>Crop Variety</TableCell>
                        <TableCell align="left" style={{ fontWeight: 'bold' }}>Harvesting Start Date</TableCell>
                        <TableCell align="left" style={{ fontWeight: 'bold' }}>Harvesting End Date</TableCell>
                        <TableCell align="right" style={{ fontWeight: 'bold' }}>Expected Yield</TableCell>
                        <TableCell align="right" style={{ fontWeight: 'bold' }}>No. Of Pickings</TableCell>
                        <TableCell align="right" style={{ fontWeight: 'bold' }}>Cultivation %</TableCell>
                        <TableCell align="center" style={{ fontWeight: 'bold' }}>Status</TableCell>
                        <TableCell align="center" style={{ fontWeight: 'bold' }}>Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {row.cropDetails.map((historyRow) => (
                        <TableRow key={historyRow.date}>
                          <TableCell component="th" scope="row">
                            {historyRow.productName}
                          </TableCell>
                          <TableCell>
                            {historyRow.varietyName}
                          </TableCell>
                          <TableCell align="left">
                            {historyRow.expectedStartDate.split("T")[0]}
                          </TableCell>
                          <TableCell align="left">
                            {historyRow.expectedEndDate.split("T")[0]}
                          </TableCell>
                          <TableCell align="right">
                            {historyRow.yield}
                          </TableCell>
                          <TableCell align="right">
                            {historyRow.noOfPikings}
                          </TableCell>
                          <TableCell align="right">
                            {historyRow.cultivationPercentage} %
                          </TableCell>
                          <TableCell align="right">
                            {historyRow.statusID == 0 ?
                              <Chip size="small" label="Active" style={{ color: 'orange' }} /> :
                              <Chip size="small" label="Pending" style={{ color: 'green' }} />
                            }
                          </TableCell>
                          <TableCell align="center">
                            <Tooltip title="Delete Crop">
                              <IconButton aria-label="delete" onClick={() => plotCropRemovePopUp(historyRow)}>
                                <Delete />
                              </IconButton>
                            </Tooltip>
                            {historyRow.isCropLifeCycle == false ?
                              <Tooltip title="Edit Crop">
                                <IconButton aria-label="delete" onClick={() => setUpdateCrop(historyRow, row)}>
                                  <EditIcon />
                                </IconButton>
                              </Tooltip> : null}
                            {historyRow.statusID == 1 ? null :
                              <Tooltip title="Early Finish">
                                <IconButton aria-label="delete" onClick={() => earlyFinishApprove(historyRow)}>
                                  <ExitToAppIcon />
                                </IconButton>
                              </Tooltip>}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Box> : <Typography variant="h6" gutterBottom component="div">
                  No Crop Details
                </Typography>}
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  const farmerProductPlotsSchema = Yup.object().shape({
    groupID: Yup.number().min(1, 'Please Select Group').required('Group required'),
    operationEntityID: Yup.number().min(1, 'Please Select Fresh Collection Center').required('Fresh Collection Center is required'),
    collectionCenterID: Yup.number().notRequired(),
    farmerID: Yup.number().min(1).min(1, 'Please Select Farmer').required('Farmer required')
  });

  const formik = useFormik({
    initialValues: {
      groupID: formData.groupID,
      operationEntityID: formData.operationEntityID,
      collectionCenterID: formData.collectionCenterID,
      farmerID: formData.farmerID,
      farmerName: formData.farmerName
    },

    validationSchema: farmerProductPlotsSchema,
    onSubmit: (values) => {
      trackPromise(SubmitForm());

    }
  });

  async function SubmitForm() {
    setIsAddButtonEnable(true);
    var res = await services.GetFarmerCropPlotDetailsByFarmerID(formik.values.farmerID, formik.values.operationEntityID, value == 0 ? false : true);
    if (res.length != 0) {
      res.forEach(x => {
        let tot = x.cropDetails.reduce((accumulator, current) => accumulator + current.cultivationPercentage, 0);
        x.totalCultivatedPrecentage = tot
      });
    }
    CheckGeoLocation()
    setPlotDetails(res)
    setIsHidden(true)
  }

  //check whether there is a geo-location for the plot
  async function CheckGeoLocation() {
    var res = await services.CheckGeoLocationByFarmerPlotMappingID(plotDetails.farmerPlotMappingID);
    setPlotDetails(res)
  }

  const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

  async function clearAll() {
    //formik.resetForm()
    setIsHidden(false);
    setPlotDetails([]);
    setIsFarmerClear(!IsFarmerClear)
    setSelectedFarmer([]);
    setValues({
      ...values,
      farmerID: "0",
      operationEntityID: "0",
    });
  }

  useEffect(() => {
    trackPromise(getPermissions());
  }, [])

  useEffect(() => {
    trackPromise(GetOperationEntityByGroupID());
  }, [formik.values.groupID]);

  useEffect(() => {
    GetRouteByFactoryID();
    trackPromise(GetFarmerDetailsByFactoryIDRouteID());
    setPlotData({
      ...plotData,
      collectionCenterID: formik.values.operationEntityID,
    })
    setPlotDetails([]);
    setIsAddButtonEnable(false);
  }, [formik.values.operationEntityID]);

  // useEffect(() => {
  //   trackPromise(GetFarmerDetailsByFactoryIDRouteID());
  // }, [formik.values.collectionCenterID]);

  useEffect(() => {
    if (isManualPickings == false) {
      trackPromise(setupPikingsDetails(cropData.date));
    }
  }, [cropData.date]);

  useEffect(() => {
    calAcres(plotData.perches);
  }, [plotData.perches]);

  useEffect(() => {
    unitTypeChange();
  }, [plotData.plotTypeID]);

  useEffect(() => {
    if (isUpdate != true) {
      setPlotData({
        ...plotData,
        perches: parseFloat(0),
      })
    }
  }, [plotData.unitID]);

  useEffect(() => {
    trackPromise(GetFarmerCollectionCenterDetailsByFarmerID(formik.values.farmerID));
    setPlotDetails([]);
    setIsAddButtonEnable(false);
  }, [formik.values.farmerID]);

  useEffect(() => {
    trackPromise(GetProductDetails(formik.values.operationEntityID, cropData.productCategoryID));
  }, [cropData.productCategoryID]);

  useEffect(() => {
    trackPromise(GetAllProductVarietyByProductID(cropData.cropID));
  }, [cropData.cropID]);

  useEffect(() => {
    if (cropData.productVarietyID != '0') {
      trackPromise(GetProductLifeCyclePikingDetailsByProductID());
    }
  }, [cropData.productVarietyID]);

  useEffect(() => {
    if (isManualPickings == false) {
      setCropData({
        ...cropData,
        date: '',
      })
    }
  }, [cropData.productCategoryID, cropData.cropID, cropData.productVarietyID, cropData.cultivationPercentage]);

  useEffect(() => {
    trackPromise(SubmitForm());

  }, [value]);

  useEffect(() => {
    if (!isUpdate) {
      plotFieldsClear1();
    }
  }, [isUpdate]);

  useEffect(() => {
    if (requestData.statusID == 1) {
      trackPromise(SubmitForm());
    }
  }, [requestData.statusID])

  async function getPermissions() {
    var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWFARMERPRODUCTPLOTS');

    if (isAuthorized === undefined) {
      navigate('/404');
    }

    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });

    setValues({
      ...values,
      groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
      operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
    })
    trackPromise(GetAllGroups());
    GetProductCategoties();
  }

  async function GetAllGroups() {
    var res = await services.GetAllGroupsForDropDown();
    if (res != null) {
      setGroupList(res);
    }
  }

  async function GetOperationEntityByGroupID() {
    var res = await services.GetAllFactoriesByGroupID(formik.values.groupID);
    if (res != null) {
      setOperationEntityList(res);
    }
  }

  async function GetRouteByFactoryID() {
    var res = await services.GetRouteByFactoryID(formik.values.operationEntityID)
    if (res != null) {
      setRoute(res);
    }
  }

  async function GetFarmerDetailsByFactoryIDRouteID() {
    var result = await services.GetFarmerDetailsByFactoryIDRouteID(formik.values.operationEntityID);
    result.forEach(x => {
      x.givenName = x.givenName == null || x.givenName == "" ? x.farmerCode : x.givenName
    })
    setFarmer(result);
  }

  async function GetProductCategoties() {
    var res = await services.GetProductCategoties()
    if (res != null) {
      setProductcatogery(res);
    }
  }

  async function GetProductDetails(OperationEntityID, ProductCategoryID) {
    var res = await services.GetProductsByFactoryIDProductcatogeryID(OperationEntityID, ProductCategoryID);
    if (res != null) {
      setProductList(res);
    }
  }

  async function GetAllProductVarietyByProductID(productID) {
    var res = await services.GetAllProductVarietyByProductID(productID);
    if (res != null) {
      setProductVarietyList(res);
    }
  }

  async function deleatePlot(data) {
    var res = await services.RemoveFarmerCropPlotDetails(data)
    if (res.statusCode === "Success") {
      toast.success(res.message);
    } else {
      toast.error(res.message);
    }
    trackPromise(SubmitForm());
  }


  async function GetFarmerCollectionCenterDetailsByFarmerID(farmerID) {
    var res = await services.GetFarmerCollectionCenterDetailsByFarmerID(farmerID);
    setFarmerCollectionCenterDetails(res)
  }

  async function addUpdateNewCrop() {
    if (isUpdate != true) {
      if (cropData.productCategoryID != '' && cropData.cropID != '' && cropData.productVarietyID != '' && cropData.cultivationPercentage != 0 && cropData.date != '') {
        var reg = new RegExp('^[1-9][0-9]?$|^100$');

        if (reg.test(cropData.cultivationPercentage) == false) {
          toast.error("Allow Only 1 - 100 Numbers For Cultivation Percentage");
          return;
        }
        else {
          if (pickingTableError == false) {
            if ((parseInt(cropDetails.totalCultivatedPrecentage) + parseInt(cropData.cultivationPercentage)) <= 100) {
              setIsLoading(true);
              try {
                var res = await services.AddFarmerCropPlotDetails(
                  cropData,
                  cropDetails,
                  pikingsDetails,
                  isManualPickings
                );
                if (res.statusCode === 'Success') {
                  toast.success(res.message);
                  cropFieldsClear();
                  setIsManualPickings(false);
                  setOpen(false);
                  SubmitForm();
                  CheckGeoLocation();
                } else {
                  toast.error(res.message);
                }
              } catch (error) {
                toast.error('An error occurred. Please try again.');
              } finally {
                setIsLoading(false);
              }

            }
            else {
              toast.error('Total Cultivation Precentage can not be exceed 100 %');
            }
          }
          else {
            toast.error('Please fill the picking required fileds');
          }
        }
      }
      else {
        toast.error('Fill The All Required Fields');
      }
    }
    else {
      if (cropData.productCategoryID != '' && cropData.cropID != '' && cropData.productVarietyID != '' && cropData.cultivationPercentage != 0 && cropData.date != '') {
        var reg = new RegExp('^[1-9][0-9]?$|^100$');
        if (reg.test(cropData.cultivationPercentage) == false) {
          toast.error("Allow Only 1 - 100 Numbers For Cultivation Percentage");
          return;
        }
        else {
          if (((parseInt(details.totalCultivatedPrecentage) - parseInt(cropDetails.cultivationPercentage)) + parseInt(cropData.cultivationPercentage)) <= 100) {

            setIsLoading(true);
            try {
              var res = await services.UpdateFarmerCropPlotDetails(
                cropData,
                cropDetails,
                pikingsDetails
              );
              if (res.statusCode === 'Success') {
                toast.success(res.message);
                cropFieldsClear();
                setOpen(false);
                SubmitForm();
                CheckGeoLocation();
              } else {
                toast.error(res.message);
              }
            } catch (error) {
              toast.error('An error occurred. Please try again.');
            } finally {
              setIsLoading(false);
            }

          }
          else {
            toast.error('Total Cultivation Precentage can not be exceed 100 %');
          }
        }
      }
      else {
        toast.error('Fill The All Required Fields');
      }
    }
  }

  async function addUpdateNewPlot() {

    const highestPlotNo = plotDetails.reduce((max, plot) => Math.max(max, plot.plotNo), 0);
    const nextPlotNo = highestPlotNo + 1;

    try {
      if (!isUpdate) {
        const requiredFields = ['plotName', 'plotMethodID', 'plotCategoryID', 'plotTypeID', 'perches'];
        const missingField = requiredFields.find(field => !plotData[field]);

        if (missingField) {
          toast.error(`${missingField.replace('ID', '')} needed`);
          return;
        }

        const existingPlot = plotDetails.find(plot => plot.plotName === plotData.plotName);
        if (existingPlot) {
          toast.error("Plot Name Already Exists");
          return;
        }

        const reg = new RegExp('^[0-9]{1,9}([.][0-9]{1,9})?$');
        if (!reg.test(plotData.perches)) {
          toast.error((plotData.unitID === 1 ? 'Acre' : plotData.unitID === 2 ? 'Perch' : 'Square ft') + " Allow Only Numbers");
          return;
        }

        const highestPlotNo = plotDetails.reduce((max, plot) => {
          const plotNo = parseInt(plot.plotNo);
          return plotNo > max ? plotNo : max;
        }, 0);
        const newPlotNo = highestPlotNo + 1;
        plotData.plotNo = newPlotNo.toString();

        const res = await services.AddFarmerPlotDetails(plotData, formik.values.farmerID);
        if (res.statusCode === "Success") {
          toast.success(res.message);
          plotFieldsClear();
          setOpenPlot(false);
        } else {
          toast.error(res.message);
        }
        trackPromise(SubmitForm());
      } else {
        const requiredFields = ['plotName', 'plotMethodID', 'plotCategoryID', 'plotTypeID', 'perches'];
        const missingField = requiredFields.find(field => !plotData[field]);

        if (missingField) {
          toast.error(`${missingField.replace('ID', '')} needed`);
          return;
        }

        const existingPlot = plotDetails.find(plot => plot.plotName === plotData.plotName && plot.plotNo !== plotData.plotNo);
        if (existingPlot) {
          toast.error("Plot Name Already Exists");
          return;
        }

        const reg = new RegExp('^[0-9]{1,9}([.][0-9]{1,9})?$');
        if (!reg.test(plotData.perches)) {
          toast.error((plotData.unitID === 1 ? 'Acre' : plotData.unitID === 2 ? 'Perch' : 'Square ft') + " Allow Only Numbers");
          return;
        }

        const res = await services.UpdateFarmerPlotDetails(plotData, cropDetails);
        if (res.statusCode === "Success") {
          toast.success(res.message);
          plotFieldsClear();
          setOpenPlot(false);
        } else {
          toast.error(res.message);
        }
        trackPromise(SubmitForm());
      }
    } catch (error) {

    }
  }


  async function RomveFarmerPlotDetails(data) {
    var res = await services.RomveFarmerPlotDetails(data)
    if (res.statusCode === "Success") {
      const deletedCount = res.deletedCount;

      toast.success(res.message);
    } else {
      toast.error(res.message);
    }
    trackPromise(SubmitForm());
  }

  async function GetProductLifeCyclePikingDetailsByProductID() {
    const newRes = await services.GetProductLifeCyclePikingDetailsByProductID(cropData.cropID, cropData.productVarietyID, plotData.plotTypeID);
    if (newRes.length != 0) {
      setIsManualPickings(false);
      setPickingTableError(false)
      setCropData({
        ...cropData,
        date: '',
        startDate: '',
        endDate: '',
        yield: '',
        noOfPikings: ''
      });
      setPikingsDetails([]);
    }
    else {
      setIsManualPickings(true);
      setCropData({
        ...cropData,
        date: '',
        startDate: '',
        endDate: '',
        yield: '',
        noOfPikings: ''
      });
      setPikingsDetails([]);
    }
  }

  async function setupPikingsDetails(datee) {
    if (datee != '') {
      if (cropData.cultivationPercentage <= 100) {
        if (cropData.cultivationPercentage != 0 && cropData.productCategoryID != '0' && cropData.cropID != '0'
          && cropData.productVarietyID != '0') {
          const newRes = await services.GetProductLifeCyclePikingDetailsByProductID(cropData.cropID, cropData.productVarietyID, plotData.plotTypeID);
          let res = _.cloneDeep(newRes);
          var result = [];
          if (res.length != 0) {
            let harvestingIntervals = res[0].harvestingIntervals
            let daysToHarvest = res[0].daysToHarvest
            let current = new Date(datee);
            current.setDate(value == 0 ? current.getDate() + daysToHarvest : current.getDate());
            res.forEach(x => {
              if (result.length != 0) {
                let newDate = current;
                newDate.setDate(newDate.getDate() + harvestingIntervals);
                let date = newDate.toISOString().split("T")[0]; 4
                let model = {
                  cropID: parseInt(cropData.cropID),
                  productVarietyID: parseInt(cropData.productVarietyID),
                  cropForecastDate: date,
                  quantity: (parseFloat(x.quantity) * parseFloat(isUpdate == true ? details.plotTypeID == 1 ? details.area / 1000 : details.acres : cropDetails.plotTypeID == 1 ? cropDetails.area / 1000 : cropDetails.acres) * parseFloat(cropData.cultivationPercentage)) / 100,
                  createdBy: parseInt(TokenDecoder.getUserIDFromToken())
                };
                result.push(model)
              }
              else {
                let date = current.toISOString().split("T")[0];
                let model = {
                  cropID: parseInt(cropData.cropID),
                  productVarietyID: parseInt(cropData.productVarietyID),
                  cropForecastDate: date,
                  quantity: (parseFloat(x.quantity) * parseFloat(isUpdate == true ? details.plotTypeID == 1 ? details.area / 1000 : details.acres : cropDetails.plotTypeID == 1 ? cropDetails.area / 1000 : cropDetails.acres) * parseFloat(cropData.cultivationPercentage)) / 100,
                  createdBy: parseInt(TokenDecoder.getUserIDFromToken())
                };
                result.push(model)
              }
            });
            setPikingsDetails(result)
            let totalYiald = 0;
            result.forEach(x => {
              totalYiald = totalYiald + parseFloat(x.quantity);
            });
            var last = result.slice(-1)[0];
            setCropData({
              ...cropData,
              startDate: result[0].cropForecastDate,
              endDate: value == 0 ? last.cropForecastDate : newRes[0].harvestingEndDate.split("T")[0],
              yield: parseFloat(totalYiald).toFixed(2),
              noOfPikings: result.length,
            });
          }
        }
        else {
          toast.error("Please Fill The Required Fields");
        }
      } else {
        toast.error("Cultivation Percentage Less than or equal to 100");
      }
    }
  }

  async function calAcres(data) {

    // var reg = new RegExp('^[0-9]{1,9}([.][0-9]{1,9})?$');

    // if (reg.test(data) == false) {
    //   toast.error("Allow Only Numbers");
    //   return;
    // }
    // else {
    if (plotData.unitID == 1) {
      setPlotData({
        ...plotData,
        acres: parseFloat(data).toFixed(2),
      })
    }
    else if (plotData.unitID == 2) {
      let acres = (data * 0.00625);
      setPlotData({
        ...plotData,
        acres: acres.toFixed(3),
      })
    }
    else {
      let acres = (data / 43560);
      setPlotData({
        ...plotData,
        acres: acres.toFixed(5),
      })
    }
    // }
  }

  async function setupdatePlot(row) {
    setIsUpdate(true);
    setOpenPlot(true);
    setCropDetails(row);
    setPlotData({
      ...plotData,
      plotNo: row.plotNo,
      plotName: row.plotName,
      plotMethodID: row.plotMethodID,
      plotCategoryID: row.plotCategoryID,
      plotTypeID: row.plotTypeID,
      unitID: row.unitID,
      collectionCenterID: row.operationEntityID,
      perches: parseFloat(row.area),
      acres: row.unitID == 1 ? row.acres.toFixed(2) : row.unitID == 2 ? row.acres.toFixed(3) : row.acres.toFixed(5)
    })
  }

  async function setUpdateCrop(row, data) {
    setPlotData({
      ...plotData,
      plotTypeID: data.plotTypeID,
    })
    setIsUpdate(true);
    setOpen(true);
    setCropDetails(row);
    setDetails(data);
    setCropData({
      ...cropData,
      productCategoryID: parseInt(row.productCategoryID),
      cropID: parseInt(row.cropID),
      productVarietyID: parseInt(row.cropVarietyID),
      cultivationPercentage: parseFloat(row.cultivationPercentage),
      date: value == 0 ? row.startDate.split("T")[0] : "",
      startDate: row.expectedStartDate,
      endDate: row.expectedEndDate.split("T")[0],
      yield: parseFloat(row.yield),
      noOfPikings: row.noOfPikings
    })
  }

  function earlyFinishApprove(data) {
    setRequestData({
      ...requestData,
      farmerID: data.farmerID,
      statusID: 0,
      farmerPlotCropMappingID: data.farmerPlotCropMappingID,
      farmerPlotMappingID: data.farmerPlotMappingID
    })
    setApproveOpen(true)
  }

  function EarlyFinishCancel() {
    setRequestData({
      ...requestData,
      farmerID: '',
      requestReason: '',
      farmerPlotCropMappingID: '',
      farmerPlotMappingID: ''
    })
    setApproveOpen(false)
  }

  // async function EarlyFinishRequestSend() {
  //   var res = await services.SendEarlyFinishCropRequest(requestData, values.groupID, values.operationEntityID);
  //   if (res.statusCode === "Success") {
  //     setRequestData({
  //       ...requestData,
  //       requestReason: '',
  //       statusID: 1,
  //     })
  //     toast.success(res.message);
  //   } else {
  //     toast.error(res.message);
  //   }

  //   setApproveOpen(false)
  // }
  const EarlyFinishRequestSend = async () => {
    const { requestReason } = requestData;
    const containsLetters = /[a-zA-Z]/.test(requestReason);
    const isNotEmpty = requestReason.trim() !== '';

    if (!isNotEmpty || !containsLetters) {
      toast.error('The input must contain at least one letter and cannot be empty.');
      return;
    }

    try {
      const res = await services.SendEarlyFinishCropRequest(requestData, values.groupID, values.operationEntityID);
      if (res.statusCode === "Success") {
        setRequestData({
          ...requestData,
          requestReason: '',
          statusID: 1,
        });
        toast.success(res.message);
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      toast.error('An error occurred while sending the request.');
    } finally {
      setApproveOpen(false);
    }
  };

  // function handleEarlyFinishRemark(e) {
  //   const target = e.target;
  //   const value = target.value;
  //   setRequestData({
  //     ...requestData,
  //     [e.target.name]: value
  //   })
  // }
  const handleEarlyFinishRemark = (e) => {
    const value = e.target.value;
    const containsLetters = /[a-zA-Z]/.test(value);

    if (value === '' || containsLetters) {
      setRequestData({ ...requestData, [e.target.name]: value });
    }
  };

  function handleChange(e) {
    const target = e.target;
    const value = target.value
    setPlotData({
      ...plotData,
      [e.target.name]: value
    });
  }

  function handleCropChange(e) {
    const target = e.target;
    const value = target.value

    setCropData({
      ...cropData,
      [e.target.name]: value
    });
  }

  function plotFieldsClear() {
    setPlotData({
      ...plotData,
      plotNo: '',
      plotName: '',
      plotMethodID: '0',
      plotCategoryID: '0',
      plotTypeID: '0',
      unitID: '1',
      perches: '0',
      acres: ''
    })
  }

  function plotFieldsClear1() {
    const highestPlotNo = plotDetails.reduce((max, plot) => {
      const plotNo = parseInt(plot.plotNo);
      return plotNo > max ? plotNo : max;
    }, 0);

    const nextPlotNo = highestPlotNo + 1;
    setPlotData({
      ...plotData,
      plotNo: (nextPlotNo + 1).toString(),
      plotName: '',
      plotMethodID: '0',
      plotCategoryID: '0',
      plotTypeID: '0',
      unitID: '1',
      perches: '0',
      acres: ''
    })
  }

  function cropFieldsClear() {
    setCropData({
      ...cropData,
      productCategoryID: '0',
      cropID: '0',
      productVarietyID: '0',
      cultivationPercentage: 0,
      date: '',
      startDate: '',
      endDate: '',
      yield: '',
      noOfPikings: ''
    })
  }

  function handleSearch(data, e) {

    setIsAddButtonEnable(true);
    if (data === undefined || data === null) {
      setValues({
        ...values,
        farmerID: '0'
      });
      return;
    } else {
      var valueV = data["farmerID"];
      var valueV2 = data["givenName"] == null ? "" : data["givenName"];
      var valueV3 = data["firstName"] == null ? "" : data["firstName"];
      var valueV4 = data["nic"] == null ? "" : data["nic"];

      setValues({
        ...values,
        farmerID: valueV.toString(),
        farmerName: valueV2.toString() + " " + valueV3.toString() + " - " + valueV4.toString()
      });
    }
  }

  async function unitTypeChange() {
    if (plotData.plotTypeID == 2) {
      const array = [];
      var model = {
        unitID: 1,
        unitName: 'Acre'
      }
      var model2 = {
        unitID: 2,
        unitName: 'Perch'
      }
      array.push(model);
      array.push(model2);
      setUnitDetails(array)
    }
    else {
      const array = [];
      var model2 = {
        unitID: 3,
        unitName: 'Square ft'
      }
      array.push(model2);
      setUnitDetails(array)
    }
  }

  async function plotRemovePopUp(data) {
    setEnableConfirmMessage(true);
    setPlotPopUpDetails(data)
  }

  async function plotCropRemovePopUp(data) {
    setEnableConfirmMessage2(true);
    setPlotCropPopUpDetails(data)
  }

  function confirmData(y) {
    if (y) {
      RomveFarmerPlotDetails(plotPopUpDetails);
    }
  }

  function confirmData2(y) {
    if (y) {
      deleatePlot(PlotCropPopUpDetails);
    }
  }

  const filterOptions = (options, { inputValue }) => {
    const trimmedInput = inputValue.trim().toLowerCase();

    const filteredOptions = options.filter(option =>
      (option.givenName && option.givenName.toLowerCase().includes(trimmedInput)) ||
      (option.nic && option.nic.toLowerCase().startsWith(trimmedInput)) ||
      (option.farmerCode && option.farmerCode.toLowerCase().startsWith(trimmedInput))
    ).filter(option => option.givenName !== null && option.nic !== null && option.farmerCode !== null);

    const exactMatchOptions = [];
    const nonExactMatchOptions = [];
    filteredOptions.forEach(option => {
      if (
        option.givenName.toLowerCase() === trimmedInput ||
        option.nic.toLowerCase() === trimmedInput ||
        option.farmerCode.toLowerCase() === trimmedInput
      ) {
        exactMatchOptions.push(option);
      } else {
        nonExactMatchOptions.push(option);
      }
    });

    // Return exact matches if any, otherwise return non-exact matches
    return exactMatchOptions.length > 0 ? exactMatchOptions : nonExactMatchOptions;
  };

  const deletePlot = (plotId) => {
    setDeletedRecordsCount(deletedRecordsCount + 1);
    setPlotDetails(prevState => prevState.filter(plot => plot.plotId !== plotId));
  };

  function handleSearchDropdownChangePrefferdName(data, e) {
    if (data === undefined || data === null) {
      setSelectedFarmer(data);
      setValues({
        ...values,
        farmerID: '0'
      });
      return;
    } else {
      setSelectedFarmer(data);
      var nameP = 'farmerID';
      var valueP = data.farmerID;
      var valueQ = data.givenName;
      var valueZ = data.firstName;
      var valueR = data.nic;
      setValues({
        ...values,
        farmerID: valueP,
        farmerName: valueQ  + " - " + valueR
      });
    }
  }

  return (
    <>
      <LoadingComponent />
      <Page title="Farmer Plot Products   |  FAPS">
        <Container maxWidth>
          <CommonPageHeader pageName={pageProps.pageheadername} leftButtonHidden={true} />
          <FormikProvider value={formik}>
            <ToastContainer position="bottom-right" pauseOnHover />
            <Form
              disabled={!(formik.isValid && formik.dirty)}
              noValidate
              onSubmit={handleSubmit}
            >
              <Stack spacing={2}>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Group *"
                    value={formik.values.groupID}
                    onChange={formik.handleChange}
                    {...getFieldProps('groupID')}
                    error={Boolean(touched.groupID && errors.groupID)}
                    helperText={touched.groupID && errors.groupID}
                    InputProps={{
                      readOnly: !permissionList.isGroupFilterEnabled
                    }}
                  >
                    <MenuItem key={0} value={0}>Select Group</MenuItem>
                    {groupList.map((option) => (
                      option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                        {option.groupName}
                      </MenuItem> : null
                    ))}
                  </TextField>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Fresh Collection Center *"
                    value={formik.values.operationEntityID}
                    onChange={formik.handleChange}
                    {...getFieldProps('operationEntityID')}
                    error={Boolean(touched.operationEntityID && errors.operationEntityID)}
                    helperText={touched.operationEntityID && errors.operationEntityID}
                    InputProps={{
                      readOnly: !permissionList.isFactoryFilterEnabled
                    }}
                  >
                    <MenuItem key={0} value={0}>Select Fresh Collection Center</MenuItem>
                    {operationEntityList.map((option) => (
                      option.factoryType == 2 ? <MenuItem key={option.factoryID} value={option.factoryID}>
                        {option.factoryName}
                      </MenuItem> : null
                    ))}
                  </TextField>
                  <Autocomplete
                    fullWidth
                    key={IsFarmerClear}
                    clearOnEscape
                    id="farmerID"
                    options={farmer}
                    filterOptions={filterOptions}
                    getOptionLabel={(option) => `${option.givenName} - ${option.nic}`}
                    onChange={(e, value) => handleSearchDropdownChangePrefferdName(value, e)}
                    renderOption={(props, option) => (
                      <li {...props}>
                        {`${option.givenName} - ${option.nic}`}
                      </li>
                    )}
                    renderInput={(params) =>
                      <TextField {...params}
                        variant="outlined"
                        name="farmerID"
                        label="Farmer Preferred Name / NIC *"
                        size="small"
                        fullWidth
                        helperText={touched.farmerID && errors.farmerID}
                        error={Boolean(touched.farmerID && errors.farmerID)}
                      />
                    }
                  />
                  <Grid item md={4} xs={12}>
                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                      <Button type="button" variant="outlined" color="error" onClick={() => clearAll()}>
                        Clear
                      </Button>
                      <Button type="submit" color="secondary" variant="outlined">
                        Search
                      </Button>
                    </Stack>
                  </Grid>
                </Stack>
                {isHidden == true ?
                  <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="left" spacing={2}>
                    <Chip
                      variant="outlined"
                      avatar={<Avatar></Avatar>}
                      label={formik.values.farmerName}
                    />
                    {plotDetails.length != 0 ?
                      <Chip
                        variant="outlined"
                        label={"Number Of Plots : " + plotDetails.length}
                      /> : null}
                    {plotDetails.length != 0 ?
                      <Chip
                        variant="outlined"
                        label={"Deleted Plot Count  : " + plotDetails[0].deletePlotCount}
                      /> : null}
                  </Stack> : null}

                <br />
                {isAddButtonEnable ?
                  <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                    <Button type="button"
                      color="secondary"
                      variant="contained"
                      disabled={!isHidden}
                      onClick={handleClickPlotOpen}
                    >
                      Add Plot
                    </Button>
                  </Stack>
                  : null}
                <>
                  {plotDetails.length != 0 ?
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                      <Card style={{ justifycontent: 'center', width: '100%' }}>
                        <Tabs value={value} style={{ position: 'center' }}
                          textColor="secondary"
                          indicatorColor="secondary"
                          onChange={handleChange2}
                          variant="fullWidth"
                          centered>
                          <Tab label="Non Seasonal" />
                          <Tab label="Seasonal" />
                        </Tabs>
                        <Paper className={classes.root}>
                          <TableContainer component={Paper}>
                            <Table aria-label="collapsible table">
                              <TableHead>
                                <TableRow>
                                  <TableCell />
                                  <TableCell style={{ fontWeight: 'bold' }}>Plot No</TableCell>
                                  <TableCell align="left" style={{ fontWeight: 'bold' }}>Plot Name</TableCell>
                                  <TableCell align="right" style={{ fontWeight: 'bold' }}>Acres</TableCell>
                                  <TableCell align="left" style={{ fontWeight: 'bold' }}>Harvesting Practice</TableCell>
                                  <TableCell align="left" style={{ fontWeight: 'bold' }}>Plot Category</TableCell>
                                  <TableCell align="left" style={{ fontWeight: 'bold' }}>Plot type</TableCell>
                                  <TableCell align="right" style={{ fontWeight: 'bold' }}>Total Cultivated Precentage</TableCell>
                                  <TableCell align="center" style={{ fontWeight: 'bold' }}>Action</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>                              
                                {plotDetails.map((row) => (
                                  <Row key={row.farmerCropPlotID} row={row} />
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Paper>
                      </Card>
                    </Stack> : <SearchNotFound searchQuery="Farmer Product Plots" />}
                </>
              </Stack>
            </Form>
          </FormikProvider>
          <Dialog fullWidth={true} maxWidth="lg" open={open} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">{isUpdate == true ? value == 0 ? "Update Non Seasonal Crop" : "Update Seasonal Crop" : value == 0 ? "Add Non Seasonal Crop"
              : "Add Seasonal Crop"}</DialogTitle>
            <DialogContent>
              <DialogContentText>
                <Container>
                  <Stack spacing={2} style={{ marginTop: '10px' }}>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                      <TextField
                        select
                        fullWidth
                        size="small"
                        id="outlined-basic"
                        name='productCategoryID'
                        variant="outlined"
                        label="Product Category *"
                        value={cropData.productCategoryID}
                        onChange={(e) => { handleCropChange(e) }}
                        InputProps={{
                          readOnly: isUpdate == true ? true : false
                        }}
                      >
                        <MenuItem key={0} value={0}> Select Product Category</MenuItem>
                        {productcatogery.map((option) => (
                          option.isActive == true ? <MenuItem key={option.productCategoryID} value={option.productCategoryID}>
                            {option.productCategoryName}
                          </MenuItem> : null
                        ))}
                      </TextField>
                      <TextField
                        select
                        fullWidth
                        size="small"
                        label="Crop *"
                        id="outlined-basic"
                        name='cropID'
                        variant="outlined"
                        value={cropData.cropID}
                        onChange={(e) => { handleCropChange(e) }}
                        InputProps={{
                          readOnly: isUpdate == true ? true : false
                        }}
                      >
                        <MenuItem key={0} value={0}>Select Crop</MenuItem>
                        {productList.map((option) => {
                          if (value == 0) {
                            return (option.isActive == false ? <MenuItem key={option.productID} value={option.productID}>
                              {option.productName}
                            </MenuItem> : null)
                          }
                          else {
                            return (option.isActive == true ? <MenuItem key={option.productID} value={option.productID}>
                              {option.productName}
                            </MenuItem> : null)
                          }
                        })}
                      </TextField>
                      <TextField select
                        fullWidth
                        size="small"
                        label="Crop Variety *"
                        id="outlined-basic"
                        name='productVarietyID'
                        variant="outlined"
                        value={cropData.productVarietyID}
                        onChange={(e) => { handleCropChange(e) }}
                        InputProps={{
                          readOnly: isUpdate == true ? true : false
                        }}
                      >
                        <MenuItem key={0} value={0}>Select Crop Variety</MenuItem>
                        {productVarietyList.map((option) => (
                          (isUpdate == true ? details.plotTypeID == option.cultivationTypeID : cropDetails.plotTypeID == option.cultivationTypeID) || option.cultivationTypeID == 0 ? <MenuItem key={option.productVarietyID} value={option.productVarietyID}>
                            {option.varietyName}
                          </MenuItem> : null
                        ))}
                      </TextField>
                      <TextField
                        fullWidth
                        id="outlined-basic"
                        name='cultivationPercentage'
                        size="small"
                        label="Cultivation Percentage *"
                        variant="outlined"
                        onChange={(e) => { handleCropChange(e) }}
                        value={cropData.cultivationPercentage}
                        InputProps={{
                          inputProps: {
                            step: 0.01,
                            type: 'number',
                          },
                        }}
                        onWheel={event => event.target.blur()}
                        onKeyDown={(evt) =>
                          (evt.key === "-") && evt.preventDefault()
                        }
                      />
                      {isManualPickings == false ?
                        <TextField
                          fullWidth
                          id="outlined-basic"
                          name='date'
                          size="small"
                          label="Start Date *"
                          type='date'
                          variant="outlined"
                          onKeyDown={onKeyDown}
                          onChange={(e) => { handleCropChange(e) }}
                          value={cropData.date}
                          InputLabelProps={{ shrink: true }}
                        /> : null}
                      {value == 1 && isManualPickings == false ?
                        <TextField
                          fullWidth
                          id="outlined-basic"
                          name='endDate'
                          size="small"
                          label="End Date *"
                          type='date'
                          variant="outlined"
                          onChange={(e) => { handleCropChange(e) }}
                          value={cropData.endDate}
                          InputLabelProps={{ shrink: true }}
                        /> : null}
                    </Stack>
                    {isManualPickings == true ?
                      <>
                        <Divider variant="middle" />
                        <CustomPickingTableTable
                          cropData={cropData}
                          setCropData={setCropData}
                          setPikingsDetails={setPikingsDetails}
                          setPickingTableError={setPickingTableError}
                        />
                        <Divider variant="middle" />
                      </>
                      : null}
                    <Stack style={{ marginTop: '30px' }} direction={{ xs: 'column', sm: 'row' }} spacing={6}>
                      <Stack style={{ marginRight: '50px' }}>
                        <Typography variant="h6" gutterBottom>
                          Harvesting Start Date :
                        </Typography>
                        <Typography variant="h6" gutterBottom>
                          {cropData.startDate == '' ? '-' : moment(cropData.startDate).format('MMM Do YYYY')}
                        </Typography>
                      </Stack>
                      <Stack style={{ marginRight: '50px' }}>
                        <Typography variant="h6" gutterBottom>
                          Harvesting End Date :
                        </Typography>
                        <Typography variant="h6" gutterBottom>
                          {cropData.endDate == '' ? '-' : moment(cropData.endDate).format('MMM Do YYYY')}
                        </Typography>
                      </Stack>
                      <Stack style={{ marginRight: '50px' }}>
                        <Typography variant="h6" gutterBottom>
                          Expected Yield :
                        </Typography>
                        <Typography variant="h6" gutterBottom>
                          {cropData.yield}
                        </Typography>
                      </Stack>
                      <Stack>
                        <Typography variant="h6" gutterBottom>
                          No Of Pickings :
                        </Typography>
                        <Typography variant="h6" gutterBottom>
                          {cropData.noOfPikings}
                        </Typography>
                      </Stack>
                    </Stack>
                  </Stack>
                </Container>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color="secondary">
                CANCEL
              </Button>
              <Button onClick={addUpdateNewCrop} color="secondary">
                {isUpdate == true ? "UPDATE" : "ADD"}
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog fullWidth={true} maxWidth="lg" open={openPlot} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">{isUpdate == true ? "Update Plot" : "Add Plot"}</DialogTitle>
            <DialogContent>
              <DialogContentText>
                <Container>
                  <Stack spacing={2} style={{ marginTop: '10px' }}>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                      <TextField
                        select
                        fullWidth
                        id="outlined-basic"
                        name='collectionCenterID'
                        size="small"
                        variant="outlined"
                        label="Fresh Collection Center *"
                        value={plotData.collectionCenterID}
                        onChange={(e) => { handleChange(e) }}
                        InputProps={{
                          readOnly: true
                        }}
                      >
                        <MenuItem key={0} value={0}>Select Fresh Collection Center</MenuItem>
                        {farmerCollectionCenterDetails.map((option) => (
                          <MenuItem key={option.collectionCenterID} value={option.collectionCenterID}>
                            {option.collectionCenterName}
                          </MenuItem>
                        ))}
                      </TextField>
                      <TextField
                        fullWidth
                        id="outlined-basic"
                        name='plotNo'
                        size="small"
                        label="Plot No *"
                        variant="outlined"
                        onChange={(e) => { handleChange(e) }}
                        value={plotData.plotNo}
                        InputProps={{
                          readOnly: true
                        }}
                      />
                      <TextField
                        fullWidth
                        id="outlined-basic"
                        name='plotName'
                        size="small"
                        label="Plot Name *"
                        variant="outlined"
                        onChange={(e) => { handleChange(e) }}
                        value={plotData.plotName}
                      />
                      <TextField select
                        fullWidth
                        id="outlined-basic"
                        name='plotMethodID'
                        size="small"
                        label="Harvesting Practice *"
                        variant="outlined"
                        onChange={(e) => { handleChange(e) }}
                        value={plotData.plotMethodID}
                      >
                        <MenuItem key={0} value={0}>Select Harvesting Practice</MenuItem>
                        <MenuItem value={1}>Bee Safe</MenuItem>
                        <MenuItem value={2}>Gap</MenuItem>
                        <MenuItem value={3}>Normal</MenuItem>
                      </TextField>
                    </Stack>
                    <Stack style={{ marginTop: '30px' }} direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                      <TextField select
                        fullWidth
                        id="outlined-basic"
                        name='plotCategoryID'
                        size="small"
                        label="Plot Category *"
                        variant="outlined"
                        onChange={(e) => { handleChange(e) }}
                        value={plotData.plotCategoryID}
                      >
                        <MenuItem key={0} value={0}>Select Plot Category</MenuItem>
                        <MenuItem value={1}>Modernize</MenuItem>
                        <MenuItem value={2}>Non Modernize</MenuItem>
                      </TextField>
                      <TextField select
                        fullWidth
                        id="outlined-basic"
                        name='plotTypeID'
                        size="small"
                        label="Plot Type *"
                        variant="outlined"
                        onChange={(e) => { handleChange(e) }}
                        value={plotData.plotTypeID}
                      >
                        <MenuItem key={0} value={0}>Select Plot Type</MenuItem>
                        <MenuItem value={1}>Tunnel</MenuItem>
                        <MenuItem value={2}>Plot</MenuItem>
                      </TextField>
                      <TextField select
                        fullWidth
                        id="outlined-basic"
                        name='unitID'
                        size="small"
                        label="Unit Type *"
                        variant="outlined"
                        onChange={(e) => { handleChange(e) }}
                        value={plotData.unitID}
                      >
                        <MenuItem key={0} value={0}>Select Unit Type</MenuItem>
                        {unitDetails.map((option) => (
                          <MenuItem key={option.unitID} value={option.unitID}>
                            {option.unitName}
                          </MenuItem>
                        ))}
                      </TextField>
                      <TextField
                        fullWidth
                        id="outlined-basic"
                        name='perches'
                        size="small"
                        label={plotData.unitID == 1 ? 'Acre *' : plotData.unitID == 2 ? 'Perch *' : 'Square ft *'}
                        variant="outlined"
                        onChange={(e) => { handleChange(e) }}
                        value={plotData.perches}
                        InputProps={{
                          inputProps: {
                            step: 0.01,
                            type: 'number',
                          },
                        }}
                        onWheel={event => event.target.blur()}
                        onKeyDown={(evt) =>
                          (evt.key === "-") && evt.preventDefault()
                        }
                      />
                    </Stack>
                    <Stack style={{ marginTop: '25px' }} width={265}>
                      <TextField
                        fullWidth
                        id="outlined-basic"
                        name='acres'
                        size="small"
                        label="Acres"
                        variant="outlined"
                        onChange={(e) => { handleChange(e) }}
                        value={plotData.acres}
                        InputProps={{
                          readOnly: true
                        }}
                      />
                    </Stack>
                  </Stack>
                </Container>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handlePlotClose} color="secondary">
                CANCEL
              </Button>
              <Button onClick={addUpdateNewPlot} color="secondary">
                {isUpdate == true ? "UPDATE" : "ADD"}
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog fullWidth={true} maxWidth='sm' onClose={EarlyFinishCancel} aria-labelledby="customized-dialog-title" open={approveOpen}>
            <DialogTitle id="customized-dialog-title" onClose={EarlyFinishCancel}>
              Early Finish Request!
            </DialogTitle>
            <DialogContent dividers>
              <Grid item md={12} xs={12}>
                <TextField
                  fullWidth
                  id="outlined-multiline-static"
                  label="Early Finish Reason*"
                  name='requestReason'
                  value={requestData.requestReason}
                  onChange={(e) => { handleEarlyFinishRemark(e) }}
                  multiline
                  rows={4}
                  variant="outlined"
                />
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button autoFocus onClick={EarlyFinishRequestSend} variant="contained" color="error">
                Request
              </Button>
              <Button autoFocus onClick={EarlyFinishCancel} variant="outlined" color="secondary">
                Cancel
              </Button>
            </DialogActions>
          </Dialog>
        </Container>


        <div hidden={true}>
          <Grid item>
            <AlertDialog confirmData={confirmData} headerMessage={message} viewPopup={EnableConfirmMessage}
              discription={"Are you sure want to remove this plot ?"} setViewPopup={setEnableConfirmMessage} />
          </Grid>
        </div>
        <div hidden={true}>
          <Grid item>
            <AlertDialog confirmData={confirmData2} headerMessage={message2} viewPopup={EnableConfirmMessage2}
              discription={"Are you sure want to remove the crop from this plot ?"} setViewPopup={setEnableConfirmMessage2} />
          </Grid>
        </div>
      </Page>
    </>
  );
}
